const config = {
    hoverClass: 'hover',
    invalidCls: 'invalid',
    hiddenCls: 'hidden',
    downKey: 40,
    upKey: 38,
    escKey: 27,
    enterKey: 13
};

export default class Menu {
    constructor(element, content, window) {
        this.$element = $(element);
        this.$target = $(this.$element.data('autocompleteTarget')).length > 0 ?
            $(this.$element.data('autocompleteTarget')) :
            this.$element.siblings('[type="hidden"]');

        this.$labelTarget = this.$element.data('autocompleteLabelTarget') !== undefined ?
            $(this.$element.data('autocompleteLabelTarget')) :
            this.$element;

        this.$content = $(content);
        this.$window = $(window);
        this.visible = false;
    }

    init() {
        this.$menuElement = this.$content.length > 0 ?
            this.$content.insertAfter(this.$element) :
            this.$element;

        this.$menuWrapper = this.$menuElement.children().length > 0 ?
            this.$menuElement.children().first() :
            this.$menuElement;

        this.$element
            .off('autocomplete:hide', '', $.proxy(this, 'hide'))
            .on('autocomplete:hide', $.proxy(this, 'hide'))
            .off('autocomplete:clear', '', $.proxy(this, 'clear'))
            .on('autocomplete:clear', $.proxy(this, 'clear'))
            .off('autocomplete:remove', '', $.proxy(this, 'remove'))
            .on('autocomplete:remove', $.proxy(this, 'remove'))
            .off('focus', '', $.proxy(this, 'show'))
            .on('focus', $.proxy(this, 'show'))
            .off('menuTrigger', '', $.proxy(this, 'toggle'))
            .on('menuTrigger', $.proxy(this, 'toggle'))
            .off('menuTrigger:close', '', $.proxy(this, 'hide'))
            .on('menuTrigger:close', $.proxy(this, 'hide'))
            .off('keypress', '', $.proxy(this, 'keypress'))
            .on('keypress', $.proxy(this, 'keypress'))
            .off('keyup', '', $.proxy(this, 'keyup'))
            .on('keyup', $.proxy(this, 'keyup'));

        this.$filter = this.$element.find('[data-autocomplete-filter]');
        this.$filter
            .off('keyup', '', $.proxy(this, 'filter'))
            .on('keyup', $.proxy(this, 'filter'));

        $(document)
            //No need to off this before as it's ok for it to be there multiple times - Raibaz
            .on('click touchend', $.proxy(this, 'clickOnDocument'));

        this.highlight();
        this.resize();

        this.$menuElement.on('click', '.js-item', $.proxy(this, 'clickOnMenu'));
        this.$menuElement.on('scroll', $.proxy(this, 'menuOnScroll'));
    }

    clickOnMenu(event) {
        let $target = $(event.currentTarget);
        let type = $target.data('type');
        let value = $target.data('value');
        let label = $target.text().trim();

        this.$target.val(value);
        this.$target.change();

        this.$labelTarget.html(label);
        this.$labelTarget.change();

        if (type) {
            this.$element.data('type', type);
        } else {
            this.$element.removeData('type');
        }

        this.$element.val(label);
        this.$element.change();

        this.hide();
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        this.$filter.val('').trigger('keyup');
    }

    clickOnDocument(event) {
        if (event.isDefaultPrevented()) {
            return;
        }

        let $target = $(event.target);

        if ($(this.$element).find($target).length || this.$menuElement.find($target).length) {
            return;
        }

        this.hide();
    }

    remove() {
        this.visible = false;
        this.$menuElement.remove();
    }

    hide() {
        this.visible = false;
        this.$menuElement.hide();
    }

    clear() {
        this.$target.val('');
    }

    show() {
        if (this.isEmpty()) {
            return;
        }

        this.visible = true;
        this.$menuElement.show();
        this.$filter.focus();
    }

    toggle() {
        if (this.visible) {
            this.hide();
        } else {
            this.show();
        }
    }

    keypress(event) {
        if (event && event.keyCode === config.enterKey) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            let $items = this.$menuElement.find('.js-item');

            if ($items.length === 0) {
                return false;
            }

            let focused = $items.filter(`.${config.hoverClass}`);

            if (focused.length === 0) {
                focused = $items.first();
            }

            focused.trigger('click');

            return false;
        }
    }

    keyup(event) {
        let items;
        let index;

        this.$element.removeClass(config.invalidCls);

        if (event && event.keyCode === config.escKey) {
            this.hide();
        }

        if (event && event.keyCode === config.downKey) {
            items = this.$menuElement.find('.js-item');
            index = items.index(items.filter('.' + config.hoverClass)) + 1; // increment focused index

            // if no any items focused or last one item focused then focus on '0' item
            if (index >= items.length || index < 0) {
                index = 0;
            }

            if (items.length > 0) {
                this.hover(index);
            }
        }

        if (event && event.keyCode === config.upKey) {
            items = this.$menuElement.find('.js-item');
            index = items.index(items.filter('.' + config.hoverClass)) - 1; // decrement focused index

            // if no any items focused or '0' item focused then focus on last one
            if (index < 0) {
                index = items.length - 1;
            }

            if (items.length > 0) {
                this.hover(index);
            }
        }
    }

    hover(index) {
        let items = this.$menuElement.find('.js-item');
        let element = items.eq(index);
        let elementTop = element.offset().top;
        let elementBottom = element.offset().top + element.outerHeight();
        let wrapperTop = this.$menuWrapper.offset().top;
        let wrapperBottom = wrapperTop + this.$menuWrapper.height();

        items.removeClass(config.hoverClass);
        element.addClass(config.hoverClass);

        // if item is out of visible area then scroll area to make item visible
        if (elementTop < wrapperTop || elementBottom > wrapperBottom) {
            this.$menuWrapper.scrollTop(elementTop + this.$menuWrapper.scrollTop() - wrapperTop);
        }
    }

    resize() {
        if (this.isEmpty()) {
            this.hide(); // hide dropdown
            this.$element.addClass(config.invalidCls); // mark as invalid
            return;
        }

        let maxHeight = this.$window.scrollTop() + this.$window.height() - this.$menuElement.offset().top;
        this.$menuWrapper.css('max-height', maxHeight);
    }

    isEmpty() {
        return this.$menuWrapper.length === 0 || this.$menuWrapper.html().trim().length === 0;
    }

    highlight() {
        let replaceValue = this.$element.val().replace(/^(.)|\s(.)/g, $1 => $1.toUpperCase());

        this.$content.find('li').each((index, el) => {
            $(el).html(
                $(el).html().replace(replaceValue, `<strong>${replaceValue}</strong>`)
            );
        });
    }

    filter() {
        let $items = this.$menuElement.find('.js-item');
        let query = this.$filter.val().trim().toLowerCase();

        $items.removeClass(config.hiddenCls);

        if (query.length === 0) {
            return;
        }

        $items.each((index, el) => {
            let name = $(el).text().toLowerCase()
                .replace(/[èé]/g, 'e')
                .replace(/[àá]/g, 'a')
                .replace(/[ò]/g, 'o')
                .replace(/[ì]/g, 'i')
                .replace(/[ù]/g, 'u');

            if (name.indexOf(query) !== 0 || !$(el).data('value')) {
                $(el).addClass(config.hiddenCls);
            }
        });
    }

    menuOnScroll() {
        if (this.$filter.is(':focus')) {
            this.$filter.blur();
        }
    }
}
